export default "__VITE_ASSET__B4XOK3D3__"